// Returns a category tree navigation with a default category already selected, if wishlist is empty it returns nothing
export const WishlistPageService_GetTreeNavigationLazy = () =>
  import("./service.grpc").then((m) => m.WishlistPageService_GetTreeNavigation);
WishlistPageService_GetTreeNavigationLazy.method =
  "aysa_api.services.wishlist.v1.page.WishlistPageService/GetTreeNavigation" as const;

// RemoveWishlistItem is used when the user removes an item from the wishlist.
//
// In case the wishlist item key can't be found, a NOT_FOUND error will be returned.
// Deprecated: Replaced by [WishlistService.RemoveProduct]
export const WishlistPageService_RemoveWishlistItemLazy = () =>
  import("./service.grpc").then(
    (m) => m.WishlistPageService_RemoveWishlistItem
  );
WishlistPageService_RemoveWishlistItemLazy.method =
  "aysa_api.services.wishlist.v1.page.WishlistPageService/RemoveWishlistItem" as const;

// GetItemStream returns a list of items (including Items) which should be shown on a wishlist stream.
//
// It returns the whole list, since pagination is disabled
//
// Deprecated - Pagination got deprecated because it was never implemented on the backend.
// The API was initially designed to support it but due to technical limitation it's unrealistic to support them.
export const WishlistPageService_GetItemStreamLazy = () =>
  import("./service.grpc").then((m) => m.WishlistPageService_GetItemStream);
WishlistPageService_GetItemStreamLazy.method =
  "aysa_api.services.wishlist.v1.page.WishlistPageService/GetItemStream" as const;

// GetItemStreamPage returns a subsequent part of the Item stream
// Takes the state from an earlier GetItemStream call, to expose a consistent state over time
//
// Deprecated - Pagination got deprecated because it was never implemented on the backend.
// The API was initially designed to support it but due to technical limitation it's unrealistic to support them.
export const WishlistPageService_GetItemStreamPageLazy = () =>
  import("./service.grpc").then((m) => m.WishlistPageService_GetItemStreamPage);
WishlistPageService_GetItemStreamPageLazy.method =
  "aysa_api.services.wishlist.v1.page.WishlistPageService/GetItemStreamPage" as const;

// GetWishlistHeaderBanner returns the data required for wishlist page header banner (BAS)
export const WishlistPageService_GetWishlistHeaderBannerLazy = () =>
  import("./service.grpc").then(
    (m) => m.WishlistPageService_GetWishlistHeaderBanner
  );
WishlistPageService_GetWishlistHeaderBannerLazy.method =
  "aysa_api.services.wishlist.v1.page.WishlistPageService/GetWishlistHeaderBanner" as const;

// GetWishlistPage is the default endpoint to retrieve wishlist page content
export const WishlistPageService_GetWishlistPageLazy = () =>
  import("./service.grpc").then((m) => m.WishlistPageService_GetWishlistPage);
WishlistPageService_GetWishlistPageLazy.method =
  "aysa_api.services.wishlist.v1.page.WishlistPageService/GetWishlistPage" as const;
